<!--  -->
<template>
  <div
    class="bottom relative bg-[linear-gradient(115deg,var(--tw-gradient-stops))] from-[#70a5f9] from-[28%] via-[#7d66ff] via-[70%] to-[#2929ed] sm:bg-[linear-gradient(145deg,var(--tw-gradient-stops))]">
    <div class="absolute inset-2 rounded-4xl bg-white/80"></div>
    <div class="px-6 lg:px-8">
      <div class="mx-auto max-w-2xl lg:max-w-7xl">
        <div class="relative pb-16 pt-20 text-center sm:py-24">
          <hgroup>
            <h2
              class="font-mono text-xs/5 font-semibold uppercase tracking-widest text-gray-500 data-[dark]:text-gray-400">
              关于我们</h2>
            <p class="mt-6 text-3xl font-medium leading-8 text-gray-950 sm:text-5xl" style="line-height: 80px;">Pkbeds
              是一家目的地旅游资源批发商，<br>致力于为旅游从业者寻找可靠且成本更低的旅行资源。</p>
          </hgroup>
          <p class="mx-auto mt-6 max-w-4xl text-sm/6 text-gray-500">
            过去5年，我们与全球酒店集团、酒店批发商、包房商、目的地管理公司、旅游SAAS服务商等旅游资源供应商建立了深厚的合作关系，为旅行社、商旅公司、地接社、定制游公司等提供全球旅游资源，包含酒店、酒店套餐、景点门票以及体验项目等目的地碎片化产品。
          </p>
          <p class="mx-auto mt-6 max-w-4xl text-sm/6 text-gray-500">我们提供B2B资源采购平台、API接口等多种合作方式让分销商轻松获取全球资源。</p>
          <div class="mt-6"><a href="mailto:partners@pkbeds.com" target="_top"><button
                class="w-full sm:w-auto inline-flex items-center justify-center px-4 py-[calc(theme(spacing.2)-1px)] rounded-full border border-transparent bg-gray-950 shadow-md whitespace-nowrap text-base font-medium text-white data-[disabled]:bg-gray-950 data-[hover]:bg-gray-800 data-[disabled]:opacity-40"
                type="button" data-headlessui-state="">业务咨询</button></a></div>
        </div>
        <div class="pb-16">
          <div class="group/row relative isolate pt-[calc(theme(spacing.2)+1px)] last:pb-[calc(theme(spacing.2)+1px)]">
            <div aria-hidden="true" class="absolute inset-y-0 left-1/2 -z-10 w-screen -translate-x-1/2">
              <div class="absolute inset-x-0 top-0 border-t border-black/5"></div>
              <div class="absolute inset-x-0 top-2 border-t border-black/5"></div>
              <div class="absolute inset-x-0 bottom-0 hidden border-b border-black/5 group-last/row:block"></div>
              <div class="absolute inset-x-0 bottom-2 hidden border-b border-black/5 group-last/row:block"></div>
            </div>
            <div class="flex">
              <div class="col-span-1 flex">
                <div class="pt-6 lg:pb-6 group/item relative"><svg viewBox="0 0 15 15" aria-hidden="true"
                    class="hidden group-first/item:block absolute size-[15px] fill-black/10 -top-2 -left-2">
                    <path d="M8 0H7V7H0V8H7V15H8V8H15V7H8V0Z"></path>
                  </svg><svg viewBox="0 0 15 15" aria-hidden="true"
                    class="absolute size-[15px] fill-black/10 -top-2 -right-2">
                    <path d="M8 0H7V7H0V8H7V15H8V8H15V7H8V0Z"></path>
                  </svg><svg viewBox="0 0 15 15" aria-hidden="true"
                    class="hidden group-last/row:group-first/item:block absolute size-[15px] fill-black/10 -bottom-2 -left-2">
                    <path d="M8 0H7V7H0V8H7V15H8V8H15V7H8V0Z"></path>
                  </svg><svg viewBox="0 0 15 15" aria-hidden="true"
                    class="hidden group-last/row:block absolute size-[15px] fill-black/10 -bottom-2 -right-2">
                    <path d="M8 0H7V7H0V8H7V15H8V8H15V7H8V0Z"></path>
                  </svg>
                  <img src="../assets/wzy.png" style="width:138px;height:35px;" />
                </div>
              </div>
              <div class="">
                <div class="ml-24 mt-8 flex items-center gap-20">
                  <div class="text-center">联系我们</div>
                  <div>如有合作意向，请您发送邮件至&nbsp;&nbsp;&nbsp;<b>partners@pkbeds.com</b></div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="flex justify-between group/row relative isolate pt-[calc(theme(spacing.2)+1px)] last:pb-[calc(theme(spacing.2)+1px)]">
            <div aria-hidden="true" class="absolute inset-y-0 left-1/2 -z-10 w-screen -translate-x-1/2">
              <div class="absolute inset-x-0 top-0 border-t border-black/5"></div>
              <div class="absolute inset-x-0 top-2 border-t border-black/5"></div>
              <div class="absolute inset-x-0 bottom-0 hidden border-b border-black/5 group-last/row:block"></div>
              <div class="absolute inset-x-0 bottom-2 hidden border-b border-black/5 group-last/row:block"></div>
            </div>
            <div>
              <div class="mt-20 py-3 group/item relative"><svg viewBox="0 0 15 15" aria-hidden="true"
                  class="hidden group-first/item:block absolute size-[15px] fill-black/10 -top-2 -left-2">
                  <path d="M8 0H7V7H0V8H7V15H8V8H15V7H8V0Z"></path>
                </svg><svg viewBox="0 0 15 15" aria-hidden="true"
                  class="absolute size-[15px] fill-black/10 -top-2 -right-2">
                  <path d="M8 0H7V7H0V8H7V15H8V8H15V7H8V0Z"></path>
                </svg><svg viewBox="0 0 15 15" aria-hidden="true"
                  class="hidden group-last/row:group-first/item:block absolute size-[15px] fill-black/10 -bottom-2 -left-2">
                  <path d="M8 0H7V7H0V8H7V15H8V8H15V7H8V0Z"></path>
                </svg><svg viewBox="0 0 15 15" aria-hidden="true"
                  class="hidden group-last/row:block absolute size-[15px] fill-black/10 -bottom-2 -right-2">
                  <path d="M8 0H7V7H0V8H7V15H8V8H15V7H8V0Z"></path>
                </svg>
                <div class="text-sm/6 text-gray-950">© 2024 Pkbeds Inc. &nbsp;&nbsp;&nbsp; 江苏湃客商旅服务有限公司
                  &nbsp;&nbsp;&nbsp;苏ICP备2020070903&nbsp;&nbsp;&nbsp; 苏公网安备32021302002251号</div>
              </div>
            </div>
            <div class="flex">
              <div class="flex items-center gap-8 py-3 group/item relative"><svg viewBox="0 0 15 15" aria-hidden="true"
                  class="hidden group-first/item:block absolute size-[15px] fill-black/10 -top-2 -left-2">
                  <path d="M8 0H7V7H0V8H7V15H8V8H15V7H8V0Z"></path>
                </svg><svg viewBox="0 0 15 15" aria-hidden="true"
                  class="absolute size-[15px] fill-black/10 -top-2 -right-2">
                  <path d="M8 0H7V7H0V8H7V15H8V8H15V7H8V0Z"></path>
                </svg><svg viewBox="0 0 15 15" aria-hidden="true"
                  class="hidden group-last/row:group-first/item:block absolute size-[15px] fill-black/10 -bottom-2 -left-2">
                  <path d="M8 0H7V7H0V8H7V15H8V8H15V7H8V0Z"></path>
                </svg><svg viewBox="0 0 15 15" aria-hidden="true"
                  class="hidden group-last/row:block absolute size-[15px] fill-black/10 -bottom-2 -right-2">
                  <path d="M8 0H7V7H0V8H7V15H8V8H15V7H8V0Z"></path>
                </svg>
                <div class="">
                  <img style="width:96px;height:96px;" src="../assets/xcx.jpg" alt="" class="w-24 rounded-md">
                  <div class="mt-3 text-xs text-slate-600">扫一扫小程序下单</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },

  components: {},

  computed: {},

  mounted() { },

  methods: {},
};
</script>
<style>
.bottom {
  box-sizing: border-box;
}

.bottom img {
  width: 100%;
}

@import '../assets/css/index.css';
</style>